import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class ContentTypeService {
  baseUrl = 'content-type';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = (onlyLastVersion, checkObjectCreation) => BaseService.get({ url: `${this.baseUrl}/get-list/${onlyLastVersion || true}/${checkObjectCreation || false}` });
  getElements = (id) => BaseService.get({ url: `${this.baseUrl}/get-list-field-elements/${id}` });
  getVersions = (id) => BaseService.get({ url: `${this.baseUrl}/get-versions/${id}` });
  getContentType = (id) => BaseService.get({ url: `${this.baseUrl}/get-list-fields/${id}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  keepActualVersion = (contentTypeData) => BaseService.post({ url: `${this.baseUrl}/keep-actual-version`, data: contentTypeData });
  getSharedFields = (contentTypeId, fieldCode) => BaseService.get({ url: `${this.baseUrl}/get-shared-fields/${contentTypeId}/${fieldCode}` });
  get = (id) => BaseService.get({ url: `${this.baseUrl}/get/${id}` });
  save = (contentTypeData) => BaseService.post({ url: `${this.baseUrl}/save`, data: contentTypeData });

  getFields = (contentTypeIDs) => BaseService.get({ url: `${this.baseUrl}/get-fields/${contentTypeIDs}` });
  getListElements = (defFieldCode, parameters) => BaseService.post({ url: `${this.baseUrl}/get-list-elements/${defFieldCode.trimEnd()}`, data: parameters });
  getListElementsByDefField = (defFieldId, parameters) => BaseService.post({ url: `${this.baseUrl}/get-list-elements-by-deffield/${defFieldId}`, data: parameters });
  searchFields = (searchText) => BaseService.get({ url: `${this.baseUrl}/search-fields?searchText=${searchText}` });
  searchFieldsByCode = (searchText) => BaseService.get({ url: `${this.baseUrl}/search-fields?searchText=${searchText}` });
  testDynamicList = (test) => BaseService.post({ url: `${this.baseUrl}/test-dynamic-list`, data: test });

  // Export Configuration
  getEncodingList = () => BaseService.get({ url: `${this.baseUrl}/get-encoding-list` });
  getExportConfig = (id) => BaseService.get({ url: `${this.baseUrl}/get-export-config/${id}` });
  saveExportConfig = (id, exportConfig) => BaseService.post({ url: `${this.baseUrl}/save-export-config/${id}`, data: exportConfig });

  // Rights
  getRights = (id) => BaseService.get({ url: `${this.baseUrl}/get-rights/${id}` });
  saveRights = (id, rights) => BaseService.post({ url: `${this.baseUrl}/save-rights/${id}`, data: rights });
  getFieldsRights = (id) => BaseService.get({ url: `${this.baseUrl}/get-fields-rights/${id}` });
  saveFieldsRights = (id, rights) => BaseService.post({ url: `${this.baseUrl}/save-fields-rights/${id}`, data: rights });

  // Auto import config
  getAutoImportConfigs = (id) => BaseService.get({ url: `${this.baseUrl}/get-auto-import-configs/${id}` });
  saveAutoImportConfigs = (id, autoImportConfigs) => BaseService.post({ url: `${this.baseUrl}/save-auto-import-configs/${id}`, data: autoImportConfigs });


  // Alerts
  getAlerts = (id) => BaseService.get({ url: `${this.baseUrl}/get-alerts/${id}` });
  saveAlerts = (id, rights) => BaseService.post({ url: `${this.baseUrl}/save-alerts/${id}`, data: rights });

  // Export/Import
  export = (ids) => Utils.file.attachment.download(`${this.baseUrl}/export/${ids}`);
  import = (ctypes) => BaseService.post({ url: `${this.baseUrl}/import`, data: ctypes });
}

export default new ContentTypeService()
